import React from "react";
import { getString } from "../../utilities";

export default function Control({
  isActive,
  className,
  label,
  icon,
  clickFunc,
  isDisabled,
  onText = getString("on.0"),
  offText = getString("off.0"),
}) {
  const activeStyle = isActive ? "active" : "";
  const controlStyle = className || "";
  const id = label.toLowerCase();

  return (
    <div className="control">
      <label htmlFor={id}>{label}</label>
      <button
        type="button"
        id={id}
        disabled={isDisabled}
        className={`control-button ${activeStyle} ${controlStyle}`}
        onClick={clickFunc}
      >
        {isActive ? onText : offText}
        {isActive ? icon.active : icon.inactive || icon.active}
      </button>
    </div>
  );
}
